import { cva, type VariantProps } from 'class-variance-authority';
import styles from './Tag.module.css';

export type TagVariants = VariantProps<typeof variants>;

const variant = {
  lavender: styles.lavender,
  papaya: styles.papaya,
  chartreuse: styles.chartreuse,
  gray: styles.gray,
};

export const variantTypes = Object.keys(variant);

export const variants = cva(styles.root, {
  variants: {
    variant,
  },
  defaultVariants: {
    variant: 'gray',
  },
});
